module.exports = __webpack_public_path__ + "img/Structural Design.82f4e3fc.png";